import React, {useEffect, useState} from "react";
import './vehicles.css'
import VehCard from "./VehCard";

const UserDetails = ({ user, onSubmit }) => {

    console.log("UserDetails Form Rendered", user);

    const [formData, setFormData] = useState(user);

    const handleChange = (key, value) => {
        setFormData({ ...formData, [key]: value });
        console.log("FormDataForm Rendered", formData);
    }

    useEffect(() => {
        if(user) setFormData(user);
    }, [user]); 

    const handleSubmit = () => {
        if(formData.pmKeys?.length < 7 ){
            alert("PMKEYS must be at least 7 digits");
            return;
        }
        if (formData.pmKeys == null || formData.pmKeys == '') {
            alert("PMKEYS is required");
            return;
        }
        if (formData.firstName == null || formData.firstName == '') {
            alert("First Name is required");
            return;
        }
        if (formData.lastName == null || formData.lastName == '') {
            alert("Last Name is required");
            return;
        }
        if (formData.callsign == null || formData.callsign == '') {
            alert("Callsign is required");
            return;
        }
        formData.windowVisible = false;
        console.log("Submitting User Details:", formData);
        onSubmit(formData);
    }

    return (
        <div className="user-form popup">
            <div>
                <h4>User Details</h4>
                <span>PMKEYS:</span>&nbsp;
                <input type="number" value={formData?.pmKeys} onChange={(e) => handleChange('pmKeys', e.target.value)} /><br /><br />
                <span>First Name:</span>&nbsp;
                <input type="text" value={formData?.firstName} onChange={(e) => handleChange('firstName', e.target.value)} /><br /><br />
                <span>Last Name:</span>&nbsp;
                <input type="text" value={formData?.lastName} onChange={(e) => handleChange('lastName', e.target.value)} /><br /><br />
                <span>Callsign:</span>&nbsp;
                <input type="text" value={formData?.callsign} onChange={(e) => handleChange('callsign', e.target.value)} />
            </div>
            <div className="save-user-details" onClick={() => handleSubmit()}>Save Details</div>
        </div>
    );
};

export default UserDetails;